var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
/** @hidden */
export var RecurrenceFrequencyEditor = function (props) {
    var value = props.value, data = props.data, onChange = props.onChange, other = __rest(props, ["value", "data", "onChange"]);
    var handleClick = React.useCallback(function (event) {
        if (onChange) {
            onChange.call(undefined, event.target.dataset.value);
        }
    }, [onChange]);
    return (React.createElement(ButtonGroup, __assign({ width: '100%' }, other), data.map(function (item) {
        return (React.createElement(Button, { type: "button", key: item.value, selected: item.value === value, onClick: handleClick, "data-value": item.value, togglable: true }, item.text));
    })));
};
//# sourceMappingURL=RecurrenceFrequencyEditor.js.map